/**
 * crmViewStore — persisted CRM view state (Fase 3.2, Jul 9 2026).
 *
 * The pipeline board's filter set (scope + search) survives reloads per
 * browser (zustand persist) — a lightweight "saved view": the board reopens
 * exactly how you left it. Multi-named shared views (DB-backed) remain a
 * future increment; this store is deliberately tiny.
 */
import { create } from "zustand";
import { persist } from "zustand/middleware";

export type BoardScope = "all" | "mine" | "stale";

interface CrmViewState {
  boardScope: BoardScope;
  boardQuery: string;
  setBoardScope: (scope: BoardScope) => void;
  setBoardQuery: (query: string) => void;
}

export const useCrmViewStore = create<CrmViewState>()(
  persist(
    (set) => ({
      boardScope: "all",
      boardQuery: "",
      setBoardScope: (boardScope) => set({ boardScope }),
      setBoardQuery: (boardQuery) => set({ boardQuery }),
    }),
    {
      name: "ando-crm-view",
      // The search text is session noise — persist only the scope.
      partialize: (state) => ({ boardScope: state.boardScope }),
    },
  ),
);
